'use strict';

/**
 * dayPortionWindow — how much of each day a request covers, by the rules palm-api's
 * `createRequestSchema` states (LEAVE-CANON-001 9f; ONE module for palm-web and palm-native since
 * Phase 9 unit 9j-1).
 *
 * A `partial` day MUST carry a window whose end is after its start, and every other portion must
 * carry NONE (the schema forbids `startTime`/`endTime` there, and the DB CHECK refuses the row). The
 * window is compared as MINUTES, exactly as the server does: `09:00` and `09:00:00` are one
 * instant, and a string compare would call that pair a valid window.
 *
 * @module status-taxonomy/dayPortionWindow
 */

const { DAY_PORTION } = require('./constants');
// The ONE clock reading — the same one the day-portion collision rule compares with.
const { clockMinutes } = require('./dayPortionOverlap');

/**
 * @param {string} startTime
 * @param {string} endTime
 * @returns {boolean} The window ends after it starts.
 */
function isWindowInOrder(startTime, endTime) {
  return clockMinutes(endTime) > clockMinutes(startTime);
}

/**
 * @param {{dayPortion: string, startTime: string, endTime: string}} form
 * @returns {boolean} Any whole portion, or a partial day with a window in order.
 */
function isPortionComplete({ dayPortion, startTime, endTime }) {
  if (dayPortion !== DAY_PORTION.PARTIAL) return true;
  return Boolean(startTime && endTime) && isWindowInOrder(startTime, endTime);
}

/**
 * The request fields for the portion — a window only with a partial day.
 *
 * @param {{dayPortion: string, startTime: string, endTime: string}} form
 * @returns {{dayPortion: string, startTime?: string, endTime?: string}}
 */
function portionPayload({ dayPortion, startTime, endTime }) {
  return dayPortion === DAY_PORTION.PARTIAL ? { dayPortion, startTime, endTime } : { dayPortion };
}

module.exports = { isWindowInOrder, isPortionComplete, portionPayload };
